import React from "react";
import {Box, Layer as LayerGrommet, Button, Heading} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {FormClose} from "grommet-icons";
import {useLazyQuery, useMutation} from "@apollo/client";
import {DELETE_USER_PACKAGE, QUERY_USER_PACKAGE, UPSERT_USER_PACKAGE} from "./UserGQL.js";
import moment from "moment";
import {Button as ButtonMui} from "@mui/material";
import Chip from '@mui/material/Chip';
import WarningIcon from '@mui/icons-material/Warning';
import LayerUserPackageAdd from "./LayerUserPackageAdd.js";
import { format } from 'date-fns';
import LayerChangeEntranceNumber from "./LayerChangeEntranceNumber.js";

export default function LayerUserPackage(props) {

    const [userPackageList,setUserPacakgeList] = React.useState([])
    const [upsertUserPackage] = useMutation(UPSERT_USER_PACKAGE);
    const [showAddLayer,setShowAddLayer] = React.useState(false);
    const [deleteUserPackage] =  useMutation(DELETE_USER_PACKAGE);
    const [showChangeEntranceNumber,setChangeEntranceNumber] = React.useState(null);

    function onEscLayer(){
        setShowAddLayer(false);
    }

    React.useEffect(()=>{
        if(props?.id){
            queryGetUserPackage({variables:{userId:props?.id}})
        }
    },[])

    const handlePayment = (id) => {
      const userPackage = userPackageList.find(item => item.id === id);
      upsertUserPackage(
        {variables:
        {input:
          {
            id:id,
            package:userPackage?.clubmatepackage_clubmatepackage?.id,
            user:userPackage?.usersregister_userregister?.id,
            isRenewal:userPackage?.is_renewal,
            paid:true,
            expireAt:userPackage?.expire_at,
            numberOfEntry:userPackage?.number_of_entry
          }
        }})
          .then((val)=>{
              alert("Pagamento aggiunto correttamente");
              queryGetUserPackage({variables:{userId:props?.id}});
          })
          .catch((err)=>{
              alert("Errore durante l'operazione");
              console.error("ERROR",err);
          })
    };

    function formatRows(data){
      const today = new Date();
    
      return data.map((item) => ({
        id: item.id,
        package: item.clubmatepackage_clubmatepackage?.name || 'N/A',
        expire_at: item.expire_at
          ? format(new Date(item.expire_at), 'yyyy-MM-dd')
          : 'Non prevista',
        number_of_entry: item.number_of_entry===null? null : item.number_of_entry >= 0 ? item.number_of_entry : 'Non previsti',
        paid: item.paid ? 'Sì' : 'No'
      }));
    };

    const [ queryGetUserPackage
      ]  = useLazyQuery(QUERY_USER_PACKAGE, {
      fetchPolicy: "no-cache",
        onCompleted: (data) => {
          if(data["clubmate_usersregister_userpackage"]){
            setUserPacakgeList(data["clubmate_usersregister_userpackage"]);
          }
        },
        onError:(error)=>{
          console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
      });

    const columns=  [
          {
            field: '',
            headerName: 'Stato abbonamento',
            width: 200,
            renderCell: (cellValues) => {
              const userPackage = (userPackageList.find(item => item.id === cellValues?.row?.id));
              const isRenewal=userPackage?.is_renewal;
                if((cellValues?.row?.number_of_entry!==null && cellValues?.row?.number_of_entry>0 ) || (cellValues?.row?.number_of_entry===null && moment(cellValues?.row?.expire_at).isAfter(new Date())) ){
                  return (
                    <center> 
                     <Chip align="center" label="ATTIVO" color="success" />
                    </center>
                  );
                }else if(isRenewal){
                  return (
                    <center> 
                     <Chip align="center" label="SCADUTO E RINNOVATO" color="warning" />
                    </center>
                  );
                }else{
                    return (
                         <Box direction={"raw"} gap="small">
                             <ButtonMui
                              startIcon={<WarningIcon/>}
                              variant="contained"
                              color="warning"
                              onClick={(event) => {
                                    //console.log("CELL VALUES",cellValues?.row);
                                    //console.log("USER_PACKAGE_LIST_CELL",userPackageList);
                                    //console.log("USER_PACKAGE_LIST_CELL_ID",userPackage);
                                    /*console.log("FORMDATA_RINNOVO",{variables:
                                      {input:
                                        {
                                          package:userPackage?.clubmatepackage_clubmatepackage?.id,
                                          paid:false,
                                          user:userPackage?.usersregister_userregister?.id
                                        }
                                      }
                                    });*/
                                    upsertUserPackage(
                                      {variables:
                                        {input:
                                          {
                                            id:cellValues?.row?.id,
                                            package:userPackage?.clubmatepackage_clubmatepackage?.id,
                                            user:userPackage?.usersregister_userregister?.id,
                                            isRenewal:true,
                                            paid:userPackage?.paid,
                                            expireAt:userPackage?.expire_at,
                                            numberOfEntry:userPackage?.number_of_entry
                                          }
                                        }
                                      })
                                        .then((val)=>{
                                            queryGetUserPackage({variables:{userId:props?.id}});
                                        })
                                        .catch((err)=>{
                                            alert("Errore durante l'operazione");
                                            console.error("ERROR",err);
                                        })
                                    upsertUserPackage(
                                      {variables:
                                        {input:
                                          {
                                            package:userPackage?.clubmatepackage_clubmatepackage?.id,
                                            paid:false,
                                            user:userPackage?.usersregister_userregister?.id
                                          }
                                        }
                                      })
                                        .then((val)=>{
                                            alert("Abbonamento rinnovato");
                                            queryGetUserPackage({variables:{userId:props?.id}});
                                        })
                                        .catch((err)=>{
                                            alert("Errore durante l'operazione");
                                            console.error("ERROR",err);
                                        })
                              }}
                            >
                             Rinnova
                            </ButtonMui>
                         </Box>
                  );
                }


              },
        },
        { field: 'package', headerName: 'Nome Pacchetto', width: 300 },
        { field: 'date_of_subscription', headerName: 'Data sottoscrizione', width: 300 },
        { field: 'expire_at', headerName: 'Scade a', width: 170 },
        { field: 'number_of_entry', headerName: 'Numero ingressi', width: 170 },
        { field: 'paid', headerName: 'Pagato', width: 300,
          renderCell: (cellValues) => {
            if(cellValues?.row?.paid==="No"){
              return(
                <ButtonMui
                variant="contained"
                color="primary"
                onClick={() => handlePayment(cellValues?.row?.id)}
                >
                  Segnala pagamento
                </ButtonMui>
              )
            }else{
              return(
                <text>Pagato</text>
              )
            }
          }
        },
        { field: 'Modifica numero ingressi', headerName: 'Modifica numero ingressi', width: 300,
            renderCell: (cellValues) => {
                if(cellValues?.row?.number_of_entry!==null){
                    return(
                        <ButtonMui
                            variant="contained"
                            color="success"
                            onClick={() => {
                                console.log(cellValues?.row)
                                setChangeEntranceNumber(cellValues?.row);
                            }
                        }
                        >
                            Modifica numero ingressi
                        </ButtonMui>
                    )
                }else{
                    return(
                        <text>Pagato</text>
                    )
                }
            }
        },
        { field: 'cancella', headerName: 'Cancella', width: 300,
            renderCell: (cellValues) => {
                return(
                    <ButtonMui
                        variant="contained"
                        color="error"
                        onClick={() =>{
                            let result = window.confirm("Sei sicuro di voler eliminare?");
                            if(result){
                                deleteUserPackage({variables:{id:cellValues["id"]}})
                                    .then((val)=>{
                                        queryGetUserPackage({variables:{userId:props?.id}});
                                    })
                            }
                        }}
                    >
                        Cancella
                    </ButtonMui>
                )
            }
        }
    ]

    return (
      <>
          <LayerGrommet style={{height: "100%", borderRadius: "20px", width: '1000px'}} onEscLayer={props?.onEscLayer} onClickOutside={props?.onEscLayer}>
            <Box height="100%" round="medium" pad="15px" background="#ffffff">
              <Button alignSelf="end" icon={<FormClose color="grey" size="35px" onClick={props?.onEscLayer}/>}></Button>
              <Box height="100%" round pad="medium" direction="column" background="#ffffff" align="center" overflow="auto">
                <Heading level="2" margin="none" size="small" style={{fontWeight:'bold',textTransform: 'uppercase'}}>
                  <Box direction="row" gap="large">
                    <h3>STATO ABBONAMENTO</h3>
                  </Box>
                </Heading>
                <ButtonMui variant="outlined" color="success" onClick={(event) => {setShowAddLayer(true)}}>AGGIUNGI UN PACCHETTO</ButtonMui>
                <Box fill gap="medium" pad={{vertical: "small"}} align="center">
                  <div style={{height: '72vh', width: '100%'}}>
                    <DataGrid
                      columns={columns}
                      rows={formatRows(userPackageList)}
                    />
                  </div>
                </Box>
              </Box>
            </Box>
          </LayerGrommet>
          {showAddLayer &&  <LayerUserPackageAdd onEscLayer={onEscLayer} id={props?.id} reloadQuery={()=>queryGetUserPackage({variables:{userId:props?.id}})}/>}
          {showChangeEntranceNumber && <LayerChangeEntranceNumber formData={showChangeEntranceNumber} onEscLayer={()=>setChangeEntranceNumber(null)} id={props?.id} reloadQuery={()=>queryGetUserPackage({variables:{userId:props?.id}})}/>}
      </>
    );
    
}